import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from '../context/AuthContext';
import { configData } from '../config/systemconfigurationconstants';
import * as AWS from 'aws-sdk';
import { useEncryption } from '../customHooks/useEncryption';
import axios from 'axios';
import lambdaConfig from "../hooks/lambdaConfig";
import UseLambdaInvocations from "../hooks/useLambdaInvocations";
let rparmid=null;
let role = '';
const Auth = () => {
    const [rid, setRid] = useState(null);
    const [userRights, setUserRights] = useState();
    const [rolesAndRights, setRolesAndRights] = useState();
    const { invokeLambda } = UseLambdaInvocations()
    const { encrypt, decrypt } = useEncryption();
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return decodeURIComponent(parts.pop().split(';').shift());
    }
    return null;
  };
    const lambda = new AWS.Lambda({
        region: configData.LAMBDA_REGION,
        accessKeyId: decrypt(getCookie('ak')),
secretAccessKey: decrypt(getCookie('sk'))
    });
    const { user } = useAuth();
    console.log('user', user)
    const navigate = useNavigate();
    const [data, setData] = useState(JSON.parse(user.attributes.identities.replace(/'/g, '"')), null, 2);
    const groupsString = user.signInUserSession.idToken.payload["custom:custom:Groups"];
    useEffect(() => {
        const isridKeyAvailable = localStorage.getItem('rid') !== null;
        if (isridKeyAvailable) {
            const ridParam = localStorage.getItem('rid');
            const istokenAvailable = localStorage.getItem('SecurityToken') !== null;
            // refId = ridParam;
            setRid(ridParam);
            rparmid=ridParam
            // localStorage.setItem('rid', ridParam)
            if (istokenAvailable) {
                oneClickurl(ridParam);
            }
            else{
                authenticateUser();
            }
        } else {
            // refId = null;
            authenticateUser();
            // setRid(null); // or handle the absence of `rid`
            // localStorage.removeItem('rid')
        }
    }, []);
    useEffect(() => {
        if (rid) {
            // Optional: perform actions that depend on `rid` being updated
            console.log("RID updated:", rid);
        }
    }, [rid]);
    const authenticateUser = async () => {
        const authPayload = {
            "Command": "LOGIN_WITH_EXTERNAL_TOKEN",
            "AuthJSON": {
                "HandshakeToken": null,
                "Provider": data[0]?.providerName,
                "ProviderToken": user.signInUserSession.idToken.payload.jti,
                "IssuedDateTime": user.signInUserSession.idToken.payload.iat,
                "IPAddress": null,
                "UserData": {
                    "FirstName": user.attributes?.given_name,
                    "LastName": user.attributes?.family_name,
                    "Email": user.attributes?.email,
                    "Group": convertGrouptoArray(user.attributes["custom:group_names"])
                }
            }
        };
        try {
            // Make the POST request with async/await
            const responseFunctionurl = await axios.post(configData.Function_url, authPayload, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            console.log("Response:", responseFunctionurl.data);
            const parsedBody = responseFunctionurl.data;
            let response = parsedBody;
            if (response.Status === true) {
                // Create a new Date object for the current time
                const now = new Date();

                // Convert the current date to a UTC string format, as required by the 'expires' attribute
                const utcDate = now.toUTCString();
                document.cookie = `ak=; expires=${utcDate}; path=/;`;
                document.cookie = `sk=; expires=${utcDate}; path=/;`;
                let encryptedak = encrypt(responseFunctionurl.data.ak)
                let encryptedsk = encrypt(responseFunctionurl.data.sk)
                document.cookie = "ak=" + encryptedak + "; SameSite=Strict; Secure";
                document.cookie = "sk=" + encryptedsk + "; SameSite=Strict; Secure";
                localStorage.setItem("UserMappingData", JSON.stringify(response.MappingInfo));
                localStorage.setItem("UserName", response.UserName);
                localStorage.setItem("FirstName", response.FirstName);
                localStorage.setItem("LastName", response.LastName);
                localStorage.setItem("SecurityToken", response.SecurityToken);
                localStorage.setItem("Jirauseremail", response.UserEmailId);
                localStorage.setItem("IsTwowyAuthEnbld", response.IsTwowyAuthEnbld);

                let defaultmapping = {};
                if (response.MappingInfo != null && response.MappingInfo.length > 0) defaultmapping = response.MappingInfo.find(el => el.IsDefault == true);
                localStorage.setItem("Role", defaultmapping.RoleName);
                localStorage.setItem("ExternalId", defaultmapping.ClientId);
                localStorage.setItem("CurrentMapping", JSON.stringify(defaultmapping));
                role = defaultmapping.RoleName;
                localStorage.setItem("AdvancedFilterUseCase", defaultmapping.UseCaseId);
                localStorage.setItem("AdvancedFilterClient", defaultmapping.ClientId);

                localStorage.setItem("mappingIDForUser", defaultmapping.UserMapId);

                localStorage.setItem("UseCaseShortName", defaultmapping.UCSN)
                localStorage.setItem("ClientShortName", defaultmapping.CSN)
                if (rparmid !== null) {
                    oneClickurl(rparmid,encryptedak,encryptedsk)
                } else {
                    getManageRolesAndRights(encryptedak,encryptedsk);
                    setRid(null)
                    rparmid = null
                    localStorage.removeItem('rid')

                }
            }

        } catch (err) {
            console.error("Error submitting form:", err);
        } finally {
        }
    };
    // for oneclick url
    const oneClickurl = (ridParam,encryptedak,encryptedsk) => {
        const lambdaforinsidemethod = new AWS.Lambda({
        region: configData.LAMBDA_REGION,
        accessKeyId: decrypt(encryptedak),
        secretAccessKey: decrypt(encryptedsk)
    });
        const data = {
            "Command": configData.GET_ONECLICK_LOANGUID,
            "RefId": ridParam,
            "SecurityId": null,
            "SecurityToken": null,
            "EventContextId": null,
            "CallerSourceId": null,
            "CallerSourceName": null
        };

        const params = {
            FunctionName: configData.LAMBDA_FUNCTION_NAME1,
            Payload: JSON.stringify(data)
        };

        lambdaforinsidemethod.invoke(params, (err, data) => {
            if (err) {
                console.log(err, err.stack);
            } else {
                let lambdaResponse = JSON.parse(data.Payload.toString());
                lambdaResponse = JSON.parse(lambdaResponse.body);
                let responseOutput = JSON.parse(lambdaResponse.Output);
                if (responseOutput.Status === true) {
                    localStorage.setItem('loanGuid', responseOutput.LoanGuid)
                    getManageRolesAndRights(encryptedak,encryptedsk);
                }
            }
        })
    }
    const getManageRolesAndRights = async (encryptedak,encryptedsk) => {
        const lambdaforinsidemethod = new AWS.Lambda({
        region: configData.LAMBDA_REGION,
        accessKeyId: decrypt(encryptedak),
        secretAccessKey: decrypt(encryptedsk)
    });
        const data = {
            "Command": configData.GET_MANAGE_ROLES_RIGHTS,
            "SecurityId": null,
            "SecurityToken": localStorage.getItem('SecurityToken'),
            "EventContextId": null,
            "CallerSourceId": null,
            "CallerSourceName": null
        };
        const params = {
            FunctionName: configData.LAMBDA_FUNCTION_NAME1,
            Payload: JSON.stringify(data)
        };
        lambdaforinsidemethod.invoke(params, (err, data) => {
            if (err) {
                console.log(err, err.stack);
            } else {
                let lambdaResponse = JSON.parse(data.Payload.toString());
                lambdaResponse = JSON.parse(lambdaResponse.body);
                let responseOutput = JSON.parse(lambdaResponse.Output);
                if (responseOutput.Status === true) {
                    localStorage.setItem("RolesAndRights", JSON.stringify(responseOutput));
                    localStorage.setItem("UserRights", JSON.stringify(responseOutput.RolesAndRights.find(el => el.RoleName == localStorage.getItem('Role')).Rights));
                    setUserRights(responseOutput.RolesAndRights.find(el => el.RoleName == localStorage.getItem('Role')).Rights);
                    setRolesAndRights(responseOutput.RolesAndRights.find(el => el.RoleName == localStorage.getItem('Role')));
                    if (rparmid === null) {
                        navigate('/dashboard');
                    }
                    else {
                        navigate('/general-information')
                        setRid(null)
                        rparmid = null
                        localStorage.removeItem('rid')
                    }

                }
            }
        })
    }
    const convertGrouptoArray = (groupstring)=>{
        const array = groupstring.replace(/[\[\]\s]/g, '').split(',');
        return array
    }
    return (
        <div>
            <h2>Authenticating...</h2>
        </div>
    );
};

export default Auth;
